import { useTranslation } from "react-i18next";
import { FaLinkedin } from "react-icons/fa";
import Button from "./components/Button";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Projects from "./components/Projects";
import Skills from "./components/Skills";

function App() {
  const { t } = useTranslation();

  return (
    <div className="bg-white text-darkBlue">
      <div className="mx-auto px-5 md:w-[90%] lg:w-[80%]">
        <Header />
        <div className="flex flex-col items-center min-h-[90vh] gap-3 pb-8 md:pt-10 md:pb-0 md:gap-10">
          <div className="flex flex-col justify-center items-center gap-5 md:flex-row">
            <div className="order-1 text-center md:text-left md:order-none">
              <p className="font-medium text-base mb-3 md:text-xl">{t("bannerSubtitle1")}</p>
              <h2 className="font-extrabold text-4xl mb-3 max-w-md md:text-5xl lg:max-w-lg">{t("bannerTitle")}</h2>
              <p className="font-semibold text-sm mb-3 opacity-70 md:text-base">{t("bannerLocation")}</p>
              <p className="text-xs max-w-md mb-4 opacity-80 leading-relaxed md:text-sm lg:max-w-lg">{t("bannerPitch")}</p>
              <div className="flex gap-2 justify-center items-center md:justify-start">
                <Button link={t("cvLink")} class="bg-cyan p-3 hover:bg-darkBlue hover:text-cyan shadow font-medium text-sm">{t("bannerBtn").toUpperCase()}</Button>
                <a href="https://www.linkedin.com/in/bruno-curi/" target="_blank" rel="noreferrer" aria-label="Linkedin profile" className="transition duration-300 hover:scale-110">
                  <FaLinkedin size={"3em"} />
                </a>
              </div>
            </div>
            <figure className="w-1/2 md:w-1/3 lg:w-1/5">
              <img src="./dev.webp" alt="Photograph of Bruno Curi" className="rounded-full shadow-md shadow-darkBlue" />
            </figure>
          </div>
          <hr className="h-px text-darkBlue w-full opacity-50 lg:w-[50vw]" />
          <Skills />
        </div>
      </div>
      <section id="about" className="bg-cyan bg-opacity-15 py-12 px-5">
        <div className="flex flex-col items-center">
          <h2 className="font-extrabold text-center mb-3 text-2xl text-darkBlue md:text-3xl">{t("about").toLowerCase()}.</h2>
          <p className="text-xs max-w-2xl mb-3 md:text-sm text-center leading-relaxed">{t("aboutP1")}</p>
          <p className="text-xs max-w-2xl mb-3 md:text-sm text-center leading-relaxed">{t("aboutP2")}</p>
          <p className="text-xs max-w-2xl md:text-sm text-center opacity-70">{t("aboutP3")}</p>
        </div>
      </section>
      <section id="projects" className="min-h-[50vh] px-5 py-20 mx-auto md:w-[90%] lg:w-[80%]">
        <h2 className="font-extrabold text-center mb-5 text-2xl text-darkBlue md:text-3xl">{t("projects").toLowerCase()}.</h2>
        <Projects />
      </section>
      <Footer />
    </div>
  );
}

export default App;
